<div class="w-full mt-10" *ngIf="hasMMSMortgage$ | async">
	<ui-note
		type="info"
		title="Existing Lender Policy Detected"
		[closableId]="matterId + '-' + titleInsuranceThirdPartyId"
		[callToActionType]="CALL_TO_ACTION_TYPES.CLOSE"
		[testHook]="testHooks.ExistingLenderPolicyDetectedNote"
	>
		<p class="mt-1 p-sm text-gray-900">
			An MMS mortgage was found on your file. As each MMS mortgage includes a
			corresponding lender policy, mortgage details have been removed from your
			order to avoid the creation of a duplicate lender policy.
		</p>
	</ui-note>
</div>
